import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_DML_REPORT_API} from '@app/reactQuery/apis/constants';

export const RQUseGetDMLReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_dml_report_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, locationId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_DML_REPORT_API,
        null,
        certificate,
        {divisionId: divisionId, locationId: locationId},
        signal,
      );
    },
    ...options,
  });
};
